// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"0d4b1ddb","976":"032f6cb4"}[chunkId] + ".chunk.css";
};